module.exports = __webpack_public_path__ + "static/caption_photos-045c02b0f3da930524fd036d724c339c.gif";